import React from 'react';
export default function DiIconCamera(props) {
  return React.createElement(
    "svg",
    {
      className: props.className,
      viewBox: "0 0 25 23"
    },
    React.createElement(
      "g",
      {
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
      },
      React.createElement(
        "g",
        {
          transform: "translate(-457.000000, -396.000000)",
          fill: "#303030",
          fillRule: "nonzero"
        },
        React.createElement("path", {
          d: "M479.656196,418.562496 C480.950138,418.562496 481.99994,417.512694 481.99994,416.218752 L481.99994,402.156285 C481.99994,400.862343 480.950138,399.812541 479.656196,399.812541 L475.359331,399.812541 L474.6611,397.957077 C474.377907,397.190467 473.650351,396.687548 472.834914,396.687548 L466.438445,396.687548 C465.461884,396.687548 464.587892,397.293035 464.246096,398.20608 L463.640609,399.812541 L459.343744,399.812541 C458.049802,399.812541 457,400.862343 457,402.156285 L457,416.218752 C457,417.512694 458.049802,418.562496 459.343744,418.562496 L479.656196,418.562496 Z M479.656196,417 L459.343744,417 C458.914067,417 458.562496,416.648429 458.562496,416.218752 L458.562496,402.156285 C458.562496,401.726608 458.914067,401.375037 459.343744,401.375037 L464.7246,401.375037 L465.706024,398.757875 C465.818319,398.455132 466.111287,398.250045 466.438445,398.250045 L472.834914,398.250045 C472.996037,398.250045 473.142521,398.352564 473.201124,398.50396 L474.280251,401.375037 L479.656196,401.375037 C480.085873,401.375037 480.437444,401.726608 480.437444,402.156285 L480.437444,416.218752 C480.437444,416.648429 480.085873,417 479.656196,417 Z M469.49997,415.04688 C472.732394,415.04688 475.359331,412.419942 475.359331,409.187519 C475.359331,405.955095 472.732394,403.328158 469.49997,403.328158 C466.267546,403.328158 463.640609,405.955095 463.640609,409.187519 C463.640609,412.419942 466.267546,415.04688 469.49997,415.04688 Z M469.49997,413.484383 C467.131812,413.484383 465.203105,411.555677 465.203105,409.187519 C465.203105,406.81936 467.131812,404.890654 469.49997,404.890654 C471.868129,404.890654 473.796835,406.81936 473.796835,409.187519 C473.796835,411.555677 471.868129,413.484383 469.49997,413.484383 Z"

        })
      )
    )
  );
}